"use client";

import { motion } from "framer-motion";
import { Star, Quote, ArrowRight } from "lucide-react";

import Image from "next/image";
import Link from "next/link";


const testimonials = [
  {
    name: "Sarah Johnson",
    visaType: "UK Skilled Worker Visa",
    content: "The transition to the UK was seamless thanks to AWS. Their expert consultants handled every detail of my visa application. Simply world-class service.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&auto=format&fit=crop"
  },
  {
    name: "Marcus Chen",
    visaType: "Canada Express Entry",
    content: "Speed and transparency were my main concerns. AWS delivered on both. I got my PR approval in just 6 months. Highly recommend their services.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&auto=format&fit=crop"
  },
  {
    name: "Elena Rodriguez",
    visaType: "Australia Student Visa",
    content: "I've worked with many consultancies, but none match the professional depth of AWS. They made my student visa process so smooth and stress-free.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&auto=format&fit=crop"
  }
];

const Testimonials = () => {
  return (
    <section className="relative bg-[#FAFAFA] py-12 sm:py-16 lg:py-20 xl:py-24 px-4 overflow-hidden">

      <div className="main-container">

        {/* HEADER */}
        <div className="text-left md:text-center mb-16">
          <p className="text-xs uppercase tracking-[0.2em] text-gray-400 mb-3">
            Testimonials
          </p>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl 2xl:text-6xl font-black text-[#000000] leading-tight">
            What Our Clients <span className="text-[#000000]">Say</span>
          </h2>

          <p className="text-gray-500 mt-5 max-w-3xl md:mx-auto text-base sm:text-lg 2xl:text-xl leading-relaxed">
            Real experiences from clients who successfully built their business with our support.
          </p>
        </div>

        {/* GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 xl:gap-8">

          {testimonials.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="group bg-[#fafafa] border border-gray-100 rounded-2xl p-6 shadow-xl transition-all duration-300"
            >

              {/* STARS */}
              <div className="flex gap-1 mb-4">
                {[...Array(t.rating)].map((_, idx) => (
                  <Star key={idx} size={14} className="text-[#B8893A] fill-[#B8893A]" />
                ))}
              </div>

              {/* CONTENT */}
              <p className="text-gray-600 text-sm leading-relaxed mb-6">
                “{t.content}”
              </p>

              {/* LINE */}
              <div className="h-px bg-gray-100 my-6"></div>

              {/* USER */}
              <div className="flex items-center gap-3">

                <div className="relative w-10 h-10 rounded-full overflow-hidden">
                  <Image
                    src={t.image}
                    alt={t.name}
                    fill
                    className="object-cover"
                  />
                </div>

                <div>
                  <h4 className="text-sm font-semibold text-black">
                    {t.name}
                  </h4>
                  <p className="text-xs text-gray-500">
                    {t.visaType}
                  </p>
                </div>

              </div>

            </motion.div>
          ))}

        </div>

      </div>

      {/* BACKGROUND GLOW */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-[#B8893A]/5 blur-3xl rounded-full -z-10"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-[#B8893A]/5 blur-3xl rounded-full -z-10"></div>

    </section>
  );
};

export default Testimonials;
